module.exports = "<i class=\"heartIcon fa\" [ngClass]=\"heartClassName\" (click)=\"changeReact($event)\"></i>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/base-reaction/base-reaction.component.html
// module id = ./src/app/commons/base-reaction/base-reaction.component.html
// module chunks = main